import { useCallback } from "react";
import { message } from "antd";
import func from "@uikit/func";

export default function useHtmlIframe(param) {
  const injectHtml = iframe => {
    if (func.isEmpty(iframe)) return;
    const content = param.htmlStr;

    let iframedoc = iframe.document;
    if (iframe.contentDocument) iframedoc = iframe.contentDocument;
    else if (iframe.contentWindow) iframedoc = iframe.contentWindow.document;

    if (iframedoc) {
      iframedoc.open();
      iframedoc.writeln(content);
      iframedoc.close();
    } else {
      func.customMsg({
        content: "Unable to render html code",
        type: "warning",
      });
    }
  };
  const iframeRef = useCallback(iframe => injectHtml(iframe), [...param.deps]);

  return [iframeRef];
}
